import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { CommonResponse } from '../app/models/commonResponse.model';
import { environment } from '../environments/environment';
// import { NotificationResponse } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  showDot: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  addNotification(payload: Notification): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.operational_url}addNotification`,
      payload
    );
  }
  // getNotification(query: string): Observable<NotificationResponse> {
  //   return this.http
  //     .get<{
  //       data: NotificationResponse;
  //     }>(`${environment.operational_url}broadcastnotification?${query}`)
  //     .pipe(map(res => res.data));
  // }

  deleteNotification(id: string): Observable<number> {
    return this.http
      .delete<{ statusCode: number }>(`${environment.operational_url}notification/${id}`)
      .pipe(map(res => res.statusCode));
  }
}
